import { Component } from 'preact';

import HourlyList from '../hourly-list/index';
import HourlyChartWrapper from '../hourly-chart/index';
import sizeAware from '../size-aware';
import handleLoadingAndError from '../handle-loading-and-error';
import { NoData } from '../no-data';
import { convertRainfall, convertTemperature, convertWindSpeed } from '../../utils/unit-converters';

/**
 * The HourlyObservations component is a wrapper around the HourlyChartWrapper and HourlyList
 * components. It switches which one is rendered based on the device screen width.
 *
 * props:
 * - data: The hourly observations data - an array of objects, each containing observation data
 * - listAlwaysExpanded: Should the hourly list be expanded
 * - listDescending: should the list be in descending order
 */

class HourlyObservations extends Component {

	componentDidMount() {
		if (typeof this.props.mounted === 'function') {
			this.props.mounted();
		}
	}

	shouldComponentUpdate(nextProps) {
		// Component should not update, instead when new props are received
		// we will redraw the chart manually.
		return nextProps.data !== this.props.data ||
			(nextProps.windowWidth !== this.props.windowWidth && !(nextProps.windowWidth < 720 && this.props.windowWidth < 720)) ||
			nextProps.listAlwaysExpanded !== this.props.listAlwaysExpanded ||
			nextProps.listDescending !== this.props.listDescending;
	}

	render(props, state, context) {

		if (props.data.length === 0) {
			return <NoData message="No Hourly Observations Data Available" />;
		}

		const renderList = props.windowWidth < 768 || context.userSettings.ui.alwaysDisplayRecentObsAsList;

		let data;

		if (props.data) {

			data = props.data.map(row => ({

				...row,

				temperature: row.temperature === null
					? null
					: Math.round(convertTemperature(row.temperature, context.userSettings.units.temperature)),

				hourlyHighWindGust: row.hourlyHighWindGust === null
					? null
					: convertWindSpeed(row.hourlyHighWindGust, context.userSettings.units.speed),

				hourlyRainfall: row.hourlyRainfall === null
					? null
					: convertRainfall(row.hourlyRainfall, context.userSettings.units.rain)

			}));

		} else {

			data = props.data;

		}

		return renderList
			? <HourlyList data={data} alwaysExpanded={props.listAlwaysExpanded} descending={props.listDescending} />
			: <HourlyChartWrapper data={data} w={props.windowWidth} />;

	}

}

export default handleLoadingAndError(sizeAware(HourlyObservations));



// WEBPACK FOOTER //
// ./components/hourly-observations/index.js